export function getValueByPath(obj, path) {
  const value = path.split('.').reduce((acc, key) => acc?.[key], obj);
  return value === null || value === undefined ? "-" : value;
}
